import OaApiService from './OaApiService';

export default class LeadAgentService extends OaApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.updateUrl = '/LeadREST/lead-agent-mapping';
  }

  getLam(agentKey, leadKey) {
    const data = {
      agentkey: agentKey,
      leadkey: leadKey,
      openonly: 0,
      referredonly: 1,
      includeleadinfo: 1,
      includealllaminfo: 1,
    };

    return this.get('/LeadAgentREST/lead-agents-info', data);
  }

  getLeadsForAgent(agentKey) {
    const data = {
      agentkey: agentKey,
      openonly: 0,
      referredonly: 1,
      includeleadinfo: 1,
    };

    return this.get('/LeadAgentREST/agent-leads-info', data);
  }

  getContactAttempts(agentKey, leadKey) {
    const data = {
      agentkey: agentKey,
      leadkey: leadKey,
    };

    return this.get('/LeadAgentREST/lead-agent-contact-attempt', data);
  }

  getContactedDetails(leadAgentMappingId) {
    return this.get('/LeadREST/lead-agent-lead-stage-contacted-detail', {}, leadAgentMappingId);
  }

  createContactAttempt(data) {
    return this.post('/LeadAgentREST/create-lead-agent-contact-attempt', data);
  }

  saveContactedDetails(data) {
    return this.post('/LeadREST/save-lead-agent-lead-stage-contacted-detail', data);
  }

  saveAppraisalDetails(data) {
    return this.post('/LeadREST/save-lead-agent-appraisal-detail', data);
  }

  saveCommissionDetails(data) {
    return this.post('/LeadREST/save-lead-agent-commission-detail', data);
  }

  saveMarketingCostDetails(data) {
    return this.post('/LeadREST/save-lead-agent-marketing-cost-detail', data);
  }

  saveListedDetails(data) {
    return this.post('/LeadREST/save-lead-stage-listed-detail', data);
  }

  saveSoldDetails(data) {
    return this.post('/LeadREST/save-lead-stage-sold-detail', data);
  }
}
